/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateInstituteHeaderRequest
 */
export interface UpdateInstituteHeaderRequest {
    /**
     * First custom line of the prescription header
     * @type {string}
     * @memberof UpdateInstituteHeaderRequest
     */
    customLine1?: string | null;
    /**
     * Second custom line of the prescription header
     * @type {string}
     * @memberof UpdateInstituteHeaderRequest
     */
    customLine2?: string | null;
}

/**
 * Check if a given object implements the UpdateInstituteHeaderRequest interface.
 */
export function instanceOfUpdateInstituteHeaderRequest(value: object): value is UpdateInstituteHeaderRequest {
    return true;
}

export function UpdateInstituteHeaderRequestFromJSON(json: any): UpdateInstituteHeaderRequest {
    return UpdateInstituteHeaderRequestFromJSONTyped(json, false);
}

export function UpdateInstituteHeaderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstituteHeaderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customLine1': json['customLine1'] == null ? undefined : json['customLine1'],
        'customLine2': json['customLine2'] == null ? undefined : json['customLine2'],
    };
}

export function UpdateInstituteHeaderRequestToJSON(json: any): UpdateInstituteHeaderRequest {
    return UpdateInstituteHeaderRequestToJSONTyped(json, false);
}

export function UpdateInstituteHeaderRequestToJSONTyped(value?: UpdateInstituteHeaderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customLine1': value['customLine1'],
        'customLine2': value['customLine2'],
    };
}

